/*
 * @Author: xg
 * @Date: 2020-03-30 14:24:09
 * @LastEditTime: 2022-02-11 14:45:29
 * @LastEditors: Please set LastEditors
 * @FilePath: \xjmediacloud\app\editingCenter\directive\esSearch\esSearch.js
 * @Description: es检索指令修改
 */

angular.module('esSerachModule', []).directive('esSerach', [
    '$state',
    'messagePublishService',
    function ($state, messagePublishService) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/directive/esSearch/esSearch.html',
            replace: true,
            link: function ($scope) {
                initData();

                /**
                 * [dealEsparams description]处理es参数
                 * @return  {[type]}  [return description]
                 */
                function dealEsparams() {
                    return {
                        serviceid: 'mlf_hybasesearch',
                        methodname: 'queryForNewMediaDoc',
                        mediaType: $scope.status.mediaType,
                        searchParams: {
                            PAGESIZE: $scope.page.PAGESIZE,
                            PAGEINDEX: 1, // 每次检索参数置为1
                            CHANNELID: $state.params.channelid || $state.params.account || '',
                            'status_model': $scope.status.status_model, // 只能用不能改
                            searchFields: [
                                {
                                    searchField: '',
                                    keywords: $scope.data.keyWords,
                                },
                                {
                                    searchField: 'docType',
                                    keywords: $scope.params.docType || $scope.params.DocType || '',
                                },
                                {
                                    searchField: 'docstatus',
                                    keywords: $scope.params.docstatus || '',
                                },
                                {
                                    searchField: 'timeType',
                                    keywords:
                                        angular.isDefined($scope.data.fromdate) && $scope.data.fromdate !== ''
                                            ? $scope.data.fromdate + ',' + $scope.data.untildate
                                            : '',
                                },
                                {
                                    searchField: 'pendingState',
                                    keywords: $scope.params.isPass ? '2' : '', // 只看通过传2，全部直接传空
                                },
                                {
                                    searchField: '_sort',
                                    keywords: 'time',
                                }
                            ],
                        }
                    };
                }

                /**
                 * [initData description]初始化数据
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    changeEsParams();
                }

                /**
                 * [changeEsParams description] 实时更新es参数
                 * @return  {[type]}  [return description]
                 */
                function changeEsParams() {
                    messagePublishService.subscribe(
                        'changeEsParams',
                        function () {
                            $scope.fullTextSearch();
                        },
                        $scope
                    );
                }

                /**
                 * [fullTextSearch description]ES搜索
                 * @param  {[type]} ev [description]
                 * @return {[type]}    [description]
                 */
                $scope.fullTextSearch = function (ev) {
                    if ((ev && ev.keyCode === 13) || !ev) {
                        messagePublishService.publish('refresh', dealEsparams());
                    }
                };
            },
        };
    },
]);
